<div (contextmenu)="manageContextMenu($event)" (click)="manageClick($event)" 
  [class.layer]="hasModals"
  [class.visible-layer]="hasModals"
  [class.invisible-layer]="!hasModals"
  class="modals-layer">

  <div *ngIf="hasModals" [id]="'modal_'+lastModal.id" class="modal" role="dialog" style="display:block!important;">
    <div class="modal-dialog modal-dialog-centered non-selectable">
      <div class="modal-content">
        <div class="modal-header" *ngIf="lastModal.title && lastModal.title != ''">
          <h5 class="modal-title non-selectable">{{ lastModal.title }}</h5>
          <button type="button" class="close" (click)="closeClick()" *ngIf="allowClose">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body non-selectable p-4" *ngIf="!lastModal.html">
          {{ lastModal.message }}
        </div>
        <div class="modal-body non-selectable p-4" *ngIf="lastModal.html" [innerHTML]="lastModal.message"></div>
        <div class="modal-footer" *ngIf="hasButtons">
          <ng-container *ngIf="lastModal.okButton || lastModal.cancelButton">
            <button *ngIf="lastModal.cancelButton" type="button" class="btn btn-secondary" 
              (click)="buttonClick(2)">{{lastModal.cancelButton}}</button>
            <button *ngIf="lastModal.okButton" type="button" class="btn btn-primary" 
              (click)="buttonClick(1)">{{lastModal.okButton}}</button>
          </ng-container>
          <ng-container *ngIf="!(lastModal.okButton || lastModal.cancelButton)">
            <button *ngFor="let button of lastModal.buttons; index as i" type="button" class="btn btn-primary"
              (click)="buttonClick(i)">{{button}}</button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

</div>